import { render, staticRenderFns } from "./Individual.vue?vue&type=template&id=7ddaaaaa&lang=pug"
import script from "./Individual.vue?vue&type=script&lang=js"
export * from "./Individual.vue?vue&type=script&lang=js"
import style0 from "./Individual.vue?vue&type=style&index=0&id=7ddaaaaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports